var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaintKittsAndNevis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_1596)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4_1596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 40C31.0459 40 40.0003 31.0457 40.0003 20C40.0003 8.9543 31.0459 0 20.0002 0C8.95455 0 0.000244141 8.9543 0.000244141 20C0.000244141 31.0457 8.95455 40 20.0002 40Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.000244141 20C0.000244141 8.95437 8.95462 0 20.0002 0C31.0459 0 40.0003 8.95437 40.0003 20",
    fill: "#338AF3"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_4_1596)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 0H-20V40H60V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-20 17.3333H17.3333V0H22.6667V17.3333H60V22.6666H22.6667V40H17.3333V22.6666H-20V17.3333Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-20 0H16.9333V16.9333H-20V0Z",
    fill: "#CE1126"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-20 0H16.9333L-20 16.9333V0Z",
    fill: "#009349"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.87917 0L-20 13.6417V16.9333H-12.9458L16.9333 3.29167V0H9.87917Z",
    fill: "#FCD116"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9167 0L-20 14.5708V16.9333H-14.9833L16.9333 2.3625V0H11.9167Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.09967 2.69307L7.93292 3.59817L9.05125 3.08549L8.44793 4.15764L9.2811 5.06281L8.07499 4.82033L7.47159 5.89244L7.32949 4.67043L6.12339 4.42786L7.24168 3.91509L7.09967 2.69307Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_1596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_1596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4_1596"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 40,
    fill: "white",
    transform: "translate(-20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaintKittsAndNevis);
export default __webpack_public_path__ + "static/media/saint_kitts_and_nevis.b1408b4cc598fdc66b6172283dcee2f3.svg";
export { ForwardRef as ReactComponent };